import {FCWithChildren} from "@/app/types/reactTypes";
import clsMerge from "@/app/util/clsMerge";
import LinkButton from "../LinkButton";
import Button from "@/app/types/Button";
import {ButtonVariant} from "../ButtonVariants";
import {Link} from "react-aria-components";

type MultiSiteItemPopoverProps = {
	buttons: Button[];
	siteURL: string;
	logo: JSX.Element;
	classes?: {
		root?: string;
		logo?: string;
	};
};

const MultiSiteItemPopover: FCWithChildren<MultiSiteItemPopoverProps> = ({
	buttons,
	siteURL,
	logo,
	classes,
	children,
}) => {
	return (
		<div
			className={clsMerge(
				"inline-flex items-stretch gap-4 border-b-4 border-corporate-gray-400 bg-white px-6 py-4 text-sm [box-shadow:_0px_4px_4px_0px_#6B6C6E33]",
				classes?.root
			)}
		>
			<div className="flex w-64 flex-col gap-[0.875rem]">
				<Link className={clsMerge("h-8", classes?.logo)} href={siteURL}>
					{logo}
				</Link>
				<div>{children}</div>
			</div>
			<div className="border-l-1 border-hyperlink" />
			<div className="flex flex-col items-stretch justify-center gap-3">
				{buttons.map((button) => (
					<LinkButton
						key={button.buttonLink}
						href={button.buttonLink}
						variant={ButtonVariant.NAVY}
						className="whitespace-nowrap bg-[#2571B1] py-2 text-sm normal-case transition-colors hover:bg-navy-800"
					>
						{button.buttonText}
					</LinkButton>
				))}
			</div>
		</div>
	);
};

export default MultiSiteItemPopover;
